export const SocialAssistanceValidation = {
    min_salary: [
        { rule: "required", message: "Min salary required" },
    ]
}